var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.logoUrl),expression:"logoUrl"}],staticClass:"logo",attrs:{"src":_vm.logoUrl,"alt":_vm.title,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }